import React from "react";
import { STATUS_STYLES, VEHICLE_STATUS } from "@/lib/api";

const LABEL_MAP = Object.fromEntries(VEHICLE_STATUS.map((s) => [s.value, s.label]));

const DOT_COLORS = {
  purchased: "bg-slate-500",
  in_transit: "bg-purple-500",
  repairing: "bg-amber-500",
  ready: "bg-emerald-500",
  listed: "bg-blue-500",
  sold: "bg-slate-400",
};

export default function StatusBadge({ status }) {
  return (
    <span data-testid={`status-${status}`} className={`chip ${STATUS_STYLES[status] || STATUS_STYLES.purchased}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${DOT_COLORS[status] || "bg-slate-500"}`} />
      {LABEL_MAP[status] || status}
    </span>
  );
}
